<section class="cart-sidebar p-5">
  <button class="button button--secondary button-link button--sm ms-2 cart-sidebar__close" (click)="closeSidebar()">
    <app-icon anchor="icon-close-xs"></app-icon>
  </button>
  <header>
    <h1 class="h3 d-flex">
      {{ prefix + '-titel' | fromDictionary }}
      @if (cart?.lines?.length) {
      <span class="ms-2 chip type-body-sm">{{ cart?.lines?.length }}</span>
      }
    </h1>
  </header>

  <main class="cart-sidebar__main">
    <ul class="cart-list mb-3">
      @for (line of cart?.lines; track line.id) {
      <li class="cart-list__item">
        <app-cart-sidebar-product-line [line]="line" [cookiePrefs]="cookiePrefs"></app-cart-sidebar-product-line>
      </li>
      }
    </ul>
  </main>

  <footer class="pt-3">
    <div class="text-end">
      <!-- <dt>
      {{ prefix + '-betaal-overzicht-btw' | fromDictionary }}
    </dt>
    <dd>
      <em>
        {{ cart?.cost?.totalTaxAmount?.amount | currency: cart?.cost?.totalTaxAmount?.currencyCode }}
      </em>
    </dd> -->

      <dt>{{ 'label-subtotaal' | fromDictionary }}</dt>
      <dd>
        <strong>
          {{ cart?.cost?.subtotalAmount?.amount | currency: cart?.cost?.subtotalAmount?.currencyCode:'symbol':'1.2-2' }}
        </strong>
      </dd>
    </div>

    <div class="text-end mt-2 d-flex flex-column gap-3">
      <a [routerLink]="['/cart']" class="button button--secondary button-outline mt-3">{{ prefix + '-knoptekst' | fromDictionary }}</a>

      @if (exemptionsChecked && !exemptionsValid) {
      <app-tax-exemption-alert (proceed)="checkout(true)"></app-tax-exemption-alert>
      }
      <button
        (click)="checkout()"
        class="button button--primary"
        [disabled]="exemptionsChecking || (exemptionsChecked && !exemptionsValid)"
      >
        {{ prefix + '-checkout-knoptekst' | fromDictionary }}
      </button>
    </div>

    @if (customer) { @if (!hasVat) {
    <app-alert class="d-block mt-4" [title]="'btw-nummer-niet-ingevuld-alert-titel' | fromDictionary" [status]="'type--info'">
      <p class="my-2">{{ 'btw-nummer-niet-ingevuld-alert-tekst' | fromDictionary }}</p>
      <a class="button button--light button--sm mt-2" [routerLink]="['/account/bewerken']" [queryParams]="{ returnUrl: '/cart' }">
        <span>{{ 'btw-nummer-niet-ingevuld-alert-knoptekst' | fromDictionary }}</span>
      </a>
    </app-alert>
    } } @else {
    <app-alert
      class="d-block mt-4"
      [message]="'btw-nummer-niet-ingevuld-geen-profiel-alert-tekst' | fromDictionary"
      [status]="'type--info'"
    >
      <a class="button button--light button--sm mt-2" [routerLink]="['/auth/inloggen']" [queryParams]="{ returnUrl: '/cart' }">
        <span>{{ 'btw-nummer-niet-ingevuld-geen-profiel-alert-knoptekst' | fromDictionary }}</span>
      </a>
    </app-alert>
    }
  </footer>
</section>
